import 'choerodon-ui/lib/style/index.less';
import 'choerodon-ui/lib/rate/style';
import './index.less';
import '../../field/style';
